import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { FullScreenLayoutComponent } from './layouts/full-screen-layout/full-screen-layout.component';
import { CustomerManagementComponent } from './modules/customer/customer-management/customer-management.component';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { CustomerModule } from './modules/customer/customer.module';
import { UserProfileComponent } from './modules/profile/user-profile/user-profile.component';
import { NzConfig, provideNzConfig } from 'ng-zorro-antd/core/config';
import { GoogleMapsModule } from '@angular/google-maps';

registerLocaleData(en);
const ngZorroConfig: NzConfig = {
  message: {
    nzTop: 50,
    nzMaxStack: 1,
  },
  table: {
    nzBordered: false,
    nzSize: 'small',
  },
};

@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    FullScreenLayoutComponent,
    CustomerManagementComponent,
    UserProfileComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CustomerModule,
    FormsModule,
    SharedModule,
    GoogleMapsModule
  ],
  providers: [
    { provide: NZ_I18N, useValue: en_US },
    provideNzConfig(ngZorroConfig),
    provideHttpClient(withInterceptors([tokenInterceptor])),
    provideAnimationsAsync(),
    provideHttpClient()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
